import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-412f2600"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-profile" }
const _hoisted_2 = { class: "container-content-profile" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Sign-up", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "signup-link" }, "here", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SignupForm = _resolveComponent("SignupForm")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_SignupForm),
      _createElementVNode("p", null, [
        _createTextVNode(" Already have an account? Click "),
        _createVNode(_component_RouterLink, { to: "/login" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createTextVNode(" to login! ")
      ])
    ])
  ]))
}